<template>
    <div class="">
        <div class="row">
            <div v-if="showTitle" class="col-md-12 mb-1 d-flex align-items-center justify-content-center">
				<div>
					<h5>{{ tabLabel }}</h5>
				</div>
				<div class="ml-auto">

					<el-checkbox border size="small" class="me-2" v-model="showchart" v-show="false">
						Show Chart
					</el-checkbox>

					<el-popover trigger="click" size="small" ref="dropdown" v-model="dropdownVisible" popper-class="dropdown-filter">
						<el-button slot="reference" type="primary" plain size="small">
							<i class="fa fa-filter"></i> &nbsp; Filter
						</el-button>
						<div>
							<div class="ps-3 pe-3 pt-1 pb-1">
								<h5><i class="fa fa-filter"></i> &nbsp; Filter {{ tabLabel }}</h5>
							</div>
							<el-divider class="m-0"></el-divider>
							<div class="dropdown-filter-form">
								<el-form label-position="top" label-width="100px">
                                    <div class="row">
                                        <div class="col-md-6">
                                            <el-form-item label="Station">
                                                <el-select v-model="stationid" clearable filterable placeholder="Select Station" size="small" style="width:100%;">
                                                    <el-option v-for="item3 in spbu.list" :key="tabName + '-' + item3.StationId" :label="item3.StationName" :value="item3.StationId">
                                                    </el-option>
                                                </el-select>
                                            </el-form-item>
                                        </div>

                                        <div class="col-md-6" v-if="false">
                                            <el-form-item label="Area">
                                                <el-radio-group v-model="area" size="small" name="area">
                                                    <el-radio-button :label="item5.value" v-for="(item5, index5) in options.area" :key="item5.value+'_'+index5" style="margin-left:0px;">{{item5.name}}</el-radio-button>
                                                </el-radio-group>
                                            </el-form-item>
                                        </div>

                                        <div class="col-md-6" >
                                            <el-form-item label="Region">
                                                <el-radio-group v-model="region" size="small" name="region">
                                                    <el-radio-button :label="item5.value" v-for="(item5, index5) in options.region" :key="item5.value+'_'+index5" style="margin-left:0px;">{{item5.name}}</el-radio-button>
                                                </el-radio-group>
                                            </el-form-item>
                                        </div>

                                        <div class="col-md-6">
                                            <el-form-item label="Owner">
                                                <el-radio-group v-model="owner" size="small" name="owner">
                                                    <el-radio-button :label="item5.value" v-for="(item5, index5) in options.owner" :key="item5.value+'_'+index5" style="margin-left:0px;">{{item5.name}}</el-radio-button>
                                                </el-radio-group>
                                            </el-form-item>
                                        </div>

                                        <div class="col-md-6" >
                                            <el-form-item label="Category">
                                                <el-radio-group v-model="category" size="small" name="area">
                                                    <el-radio-button :label="item5.value" v-for="(item5, index5) in options.category" :key="item5.value+'_'+index5" style="margin-left:0px;">{{item5.name}}</el-radio-button>
                                                </el-radio-group>
                                            </el-form-item>
                                        </div>

                                        <div class="col-md-6" >
                                            <el-form-item label="Status">
                                                <el-radio-group v-model="subcategory" size="small" name="status">
                                                    <el-radio-button :label="item5.value" v-for="(item5, index5) in options.subcategory" :key="item5.value+'_'+index5" style="margin-left:0px;">{{item5.name}}</el-radio-button>
                                                </el-radio-group>
                                            </el-form-item>
                                        </div>

                                        <div class="col-md-6" >
                                            <el-form-item label="Status Mitra">
                                                <el-radio-group v-model="status" size="small" name="status_mitra">
                                                    <el-radio-button :label="item5.value" v-for="(item5, index5) in options.status" :key="item5.value+'_'+index5" style="margin-left:0px;">{{item5.name}}</el-radio-button>
                                                </el-radio-group>
                                            </el-form-item>
                                        </div>

                                    </div>
                                </el-form>
							</div>
							<el-divider class="m-0"></el-divider>
							<div class="py-2 px-4">
								<div class="row">
									<div class="col-md-12 d-flex align-items-center">
										<div class="ml-auto">
											<el-button type="danger" size="medium" @click="closeDropdownForm" style="min-width:100px;"><i class="fa fa-close"></i> &nbsp; Close</el-button>
											<el-button type="primary" size="medium" :loading="loading.table" @click="applyFilter" style="min-width:100px;"><i class="fa fa-check"></i> &nbsp; Apply Filter</el-button>
										</div>
									</div>
								</div>
							</div>
						</div>
					</el-popover>

					<el-button class="ms-2" type="success" plain size="small" @click="exportExcel()" v-if="reportdata?.data?.length">
						<i class="fa fa-file-excel"></i> &nbsp; Export
					</el-button>
					<vue-excel-xlsx
						v-show="false"
						ref="excelExport"
						:data="dataXLSX(reportdata)"
						:columns="columnXLSX(reportdata)"
						:file-name="'Property Management ' + tabLabel"
						:file-type="'xlsx'"
						:sheet-name="'sheet1'"
						>
						<i class="far fa-file-excel"></i>
					</vue-excel-xlsx>

				</div>
			</div>

            <div class="col-md-12 mb-4" v-if="!showTitle">
                <div>
                    <el-collapse>
                        <el-collapse-item>
                            <template slot="title">
                                <span style="color:#606266;font-size:14px;"><i class="header-icon el-icon-search"></i>&nbsp;&nbsp;&nbsp;Filter</span>
                            </template>
                            <el-form label-position="top" label-width="100px">
                                <div class="row">
                                    <div class="col-md-6">
                                        <el-form-item label="Station">
                                            <el-select v-model="stationid" clearable filterable placeholder="Select Station" size="small" style="width:100%;">
                                                <el-option v-for="item3 in spbu.list" :key="tabName + '-' + item3.StationId" :label="item3.StationName" :value="item3.StationId">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                    </div>

                                    <div class="col-md-6" >
                                        <el-form-item label="Area">
                                            <el-radio-group v-model="area" size="small" name="area">
                                                <el-radio-button :label="item5.value" v-for="(item5, index5) in options.area" :key="item5.value+'_'+index5" style="margin-left:0px;">{{item5.name}}</el-radio-button>
                                            </el-radio-group>
                                        </el-form-item>
                                    </div>

                                    <div class="col-md-3">
                                        <el-form-item label="Owner">
                                            <el-radio-group v-model="owner" size="small" name="owner">
                                                <el-radio-button :label="item5.value" v-for="(item5, index5) in options.owner" :key="item5.value+'_'+index5" style="margin-left:0px;">{{item5.name}}</el-radio-button>
                                            </el-radio-group>
                                        </el-form-item>
                                    </div>

                                    <div class="col-md-3" >
                                        <el-form-item label="Category">
                                            <el-radio-group v-model="category" size="small" name="area">
                                                <el-radio-button :label="item5.value" v-for="(item5, index5) in options.category" :key="item5.value+'_'+index5" style="margin-left:0px;">{{item5.name}}</el-radio-button>
                                            </el-radio-group>
                                        </el-form-item>
                                    </div>

                                    <div class="col-md-4" >
                                        <el-form-item label="Sub Category">
                                            <el-radio-group v-model="subcategory" size="small" name="area">
                                                <el-radio-button :label="item5.value" v-for="(item5, index5) in options.subcategory" :key="item5.value+'_'+index5" style="margin-left:0px;">{{item5.name}}</el-radio-button>
                                            </el-radio-group>
                                        </el-form-item>
                                    </div>

                                    <div class="col-md-6" >
                                        <el-form-item label="Status">
                                            <el-radio-group v-model="status" size="small" name="area">
                                                <el-radio-button :label="item5.value" v-for="(item5, index5) in options.status" :key="item5.value+'_'+index5" style="margin-left:0px;">{{item5.name}}</el-radio-button>
                                            </el-radio-group>
                                        </el-form-item>
                                    </div>

                                </div>
                                <div class="row mt-2">
                                    <div class="col-md-6">
                                        <el-button type="primary" size="medium" :loading="loading.table" @click="applyFilter" style="width:100%;">Apply Filter</el-button>
                                    </div>
                                </div>
                            </el-form>
                        </el-collapse-item>
                    </el-collapse>
                </div>
            </div>

            <div class="col-md-12 mt-1">
                <ReportResultTable :reportname="'NFRReport'" :reportdata="reportdata" :loading="loading.table" :reporturl="urlRequestParams" :issuccess="loading.isSuccess"/>
            </div>

        </div>
    </div>
</template>

<script>
import Fuel from '@/components/page/Fuel.js'
import ReportResultTable from '@/views/pages/ReportResultTable2Custom.vue'
import {Rainbow, Config,Penanggalan, AxiosWithJar } from '@/utility.js'
export default
{
	extends:Fuel,
	components: {
        ReportResultTable,
    },
    props: ['tabIndex','tabName', 'tabLabel', 'showTitle'],
    data(){
		return {
			reportdata: [],
            urlRequestParams: '',
            plant: '',
            stationid: '',
            stationtype: '',
            area: '',
            region: this.$route.query.region ? this.$route.query.region : '',
            owner: '',
            lokasi: '',
            category: '',
            subcategory: '',
            status: '',
            options: {
                area:[
					{ value: "", name: "ALL" },
					{ value: "1", name: "1" },
					{ value: "2", name: "2" },
					{ value: "3", name: "3" },
					{ value: "4", name: "4" },
					{ value: "5", name: "5" },
				],
                region:[
					{ value: "", name: "ALL" },
					//{ value: "region", name: "BY REGION", field: "RegionPertareId" },
					{ value: "1", name: "1" },
					{ value: "2", name: "2" },
					{ value: "3", name: "3" },
					{ value: "4", name: "4" },
					{ value: "5", name: "5" },
					{ value: "6", name: "6" },
					{ value: "7", name: "7" },
				],
				owner:[
					{ value: "", name: "ALL" },
					//{ value: "by_owner", name: "BY OWNER" },
					{ value: "COCO", name: "COCO" },
					{ value: "KSO", name: "KSO" },
					{ value: "TAC", name: "TAC" },
				],
                category:[
					{ value: "", name: "ALL" },
					{ value: "Driveway", name: "Driveway" },
					{ value: "Ruangan", name: "Ruangan" },
					{ value: "Lahan", name: "Lahan" },
				],
                subcategory:[
					{ value: "", name: "ALL" },
					{ value: "Kosong", name: "Kosong" },
					{ value: "Terisi", name: "Terisi" },
				],
                status:[
					{ value: "", name: "ALL" },
					//{ value: "PTPR", name: "PTPR" },
					{ value: "Pertare", name: "Pertare" },
					{ value: "External", name: "External" },
					{ value: "Ruang Kosong", name: "Ruang Kosong" },
				],
            },

            loading: {
                table: false,
                isSuccess: false,
            },

            showchart: false,

            is2024OrBelow: false,
			is2025OrAbove: true,
			dropdownVisible: false,
        }
    },
    computed:{

	},
    watch:{

    },
    mounted(){
        this.$emit('childrenRoute');
        this.loadStationList();
        //this.getData()
    },
    methods: {
        async getData() {
			this.urlRequestParams = Config().apiURL
			this.urlRequestParams += '/v1/nfr/nfr?'

            this.urlRequestParams += '&plant='+this.plant
			this.urlRequestParams += '&station='+this.stationid
			this.urlRequestParams += '&type='+this.stationtype
			this.urlRequestParams += '&area='+this.area
            this.urlRequestParams += '&region='+this.region
			this.urlRequestParams += '&owner='+this.owner
			this.urlRequestParams += '&lokasi='+this.lokasi
			this.urlRequestParams += '&category='+this.category
			this.urlRequestParams += '&subcategory='+this.subcategory
			this.urlRequestParams += '&status='+this.status

            this.loading.table = true;
			this.loading.isSuccess = false;
			AxiosWithJar().get(this.urlRequestParams)
				.then((response)=>{
					this.loading.isSuccess = true;
					this.reportdata = response.data;

				})
				.catch(error => {
					console.log(error)
					//this.errored = true
					//error.response.data
				})
				.finally(() => {
					this.loading.table = false;
				})
        },

        applyFilter() {
            this.dropdownVisible = false;
            this.getData();
        },

        exportExcel() {
			this.$refs["excelExport"].exportExcel();
			//console.log('export excel');
		},

		closeDropdownForm() {
			this.dropdownVisible = false;
		},
    }
}
</script>
